module.exports = __webpack_public_path__ + "static/media/img22.d5755c3c.JPG";